import React from "react";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Alert from "@mui/material/Alert";
import CircularProgress from "@mui/material/CircularProgress";
import SendIcon from "@mui/icons-material/Send";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { alpha } from "@mui/material/styles";

export default function QuickCaptureForm({
  quickData,
  errors,
  submitting,
  submitError,
  updateQuickField,
  onSubmit,
}) {
  const handleWhatsAppChange = (e) => {
    const raw = e.target.value.replace(/\D/g, "").slice(0, 11);
    updateQuickField("whatsapp", raw);
  };

  const formatWhatsApp = (digits) => {
    if (!digits) return "";
    if (digits.length <= 2) return `(${digits}`;
    if (digits.length <= 7) return `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      onSubmit();
    }
  };

  return (
    <>
      <Stack spacing={0.5} sx={{ mb: 3 }}>
        <Typography variant="h6" fontWeight={700}>
          Comece agora
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Preencha seus dados e nossa equipe entra em contato.
        </Typography>
      </Stack>

      <Grid container spacing={2.5}>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Seu nome"
            value={quickData.full_name}
            onChange={(e) => updateQuickField("full_name", e.target.value)}
            onKeyDown={handleKeyDown}
            error={!!errors.full_name}
            helperText={errors.full_name}
            size="small"
            autoFocus
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="WhatsApp"
            value={formatWhatsApp(quickData.whatsapp)}
            onChange={handleWhatsAppChange}
            onKeyDown={handleKeyDown}
            error={!!errors.whatsapp}
            helperText={errors.whatsapp || "DDD + número"}
            placeholder="(11) 99999-9999"
            size="small"
            InputProps={{
              startAdornment: (
                <WhatsAppIcon
                  sx={{
                    mr: 1,
                    fontSize: 20,
                    color: errors.whatsapp
                      ? "error.main"
                      : alpha("#25D366", 0.7),
                  }}
                />
              ),
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Nome do restaurante"
            value={quickData.restaurant_name}
            onChange={(e) =>
              updateQuickField("restaurant_name", e.target.value)
            }
            onKeyDown={handleKeyDown}
            error={!!errors.restaurant_name}
            helperText={errors.restaurant_name}
            placeholder="Ex: Pizzaria do João"
            size="small"
          />
        </Grid>
      </Grid>

      {submitError && (
        <Alert severity="error" sx={{ mt: 2 }}>
          {submitError}
        </Alert>
      )}

      <Button
        fullWidth
        variant="contained"
        endIcon={
          submitting ? (
            <CircularProgress size={18} color="inherit" />
          ) : (
            <SendIcon />
          )
        }
        onClick={onSubmit}
        disabled={submitting}
        sx={{
          mt: 3,
          py: 1.3,
          borderRadius: "8px",
          textTransform: "none",
          fontWeight: 700,
          fontSize: "0.95rem",
          background: "linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)",
          boxShadow: "0 4px 16px rgba(37,99,235,0.3)",
          "&:hover": {
            boxShadow: "0 8px 24px rgba(37,99,235,0.4)",
          },
        }}
      >
        {submitting ? "Enviando..." : "Tenho interesse"}
      </Button>
    </>
  );
}
